<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>采购计划信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备货方式：">
              {{
              orderContractStockupPurchaseListsVo.stockupType || "--"
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="备货仓库：">
              {{
              orderContractStockupPurchaseListsVo.storageName || "--"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库地址：">
              {{
              orderContractStockupPurchaseListsVo.storageAddress || "--"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              {{
              orderContractStockupPurchaseListsVo.storagePhone || "--"
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-show="$route.query.type !== 'result' && list.length !==0" class="item-box-content">
      <div class="title-font-style">
        <span>待采购清单</span>
      </div>
      <div style="margin-top:20px;overflow-x:scroll;">
        <table border class="table-tr">
          <thead>
            <tr class="table-tr-td table-own">
              <th style="width:200px;">采购计划编号</th>
              <th style="width:100px;">品牌</th>
              <th style="width:100px;">系列</th>
              <th style="width:200px;">产品名称</th>
              <th style="width:100px;">型号</th>
              <th style="width:100px;">订货号</th>
              <th style="width:100px;">单位</th>
              <th style="width:80px;">采购数量</th>
              <th style="width:100px;">单品报价</th>
              <th style="width:100px;">报价总额</th>
              <th style="width:100px;">询价来源</th>
              <th style="width:200px;">询价供应商</th>
              <th style="width:80px;">类型</th>
              <th style="width:150px;">货期</th>
              <th style="width:150px;">预计发货时间</th>
              <th style="width:150px;">计划生成时间</th>
              <th style="width:80px;">系统报价</th>
            </tr>
          </thead>
          <draggable
            v-model="list"
            :options="{
              group: 'people',
              sort: false,
              scroll: true,
              scrollSensitivity: 200
            }"
            @change="change"
            @start="start"
            @end="end"
            element="tbody"
          >
            <tr v-for="(items, index) in list" class="table-tr-td" :key="index">
              <td>{{ items.ocspCode }}</td>
              <td>{{ items.brandName }}</td>
              <td>{{ items.seriesName }}</td>
              <td>{{ items.proName }}</td>
              <td>{{ items.proType }}</td>
              <td>{{ items.orderNumber }}</td>
              <td>{{ items.cbUnit }}</td>
              <td>{{ items.stockupCount }}</td>
              <td>{{ items.cbPrice }}</td>
              <td>{{ items.stockupCount * items.cbPrice }}</td>
              <td>{{ cbPriceSource[items.cbPriceSource - 1] }}</td>
              <td>{{ items.suName }}</td>
              <td>{{ items.cbExtype }}</td>
              <td>{{ items.cbExtimeValue }}</td>
              <td>{{ items.deliveryTime | dateFilter }}</td>
              <td>{{ items.createDate | dateFilter }}</td>
              <td class="approval" @click="onSee(items, index)">查看</td>
            </tr>
          </draggable>
        </table>
      </div>
      <div style="margin-top:20px">
        <el-button type="primary" @click="onAllFold" plain>全部调入</el-button>
      </div>
      <p>可通过拖动产品的方式灵活设置配货方案</p>
    </div>
    <div v-show="$route.query.type !== 'result'" class="item-box-content">
      <div class="title-font-style">
        <span>采购执行区</span>
      </div>
      <div v-for="(item, index) in procurementList" :key="index">
        <el-form style="padding:20px 30px 0 30px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="供应商名称：">
                <span class="approval">{{ item.suName }}</span>
                <el-button
                  style="margin-left:20px;"
                  type="primary"
                  plain
                  @click="clickChangeSupplier(index)"
                >更换供应商</el-button>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="供应商类型：">
                {{
                status[item.suType - 1]
                }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="贸易额：">{{ item.amounts|priceFilterNum }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合同总数：">
                {{
                item.pcbCount
                }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="可用余额：">
                {{
                item.accountBalance|priceFilterNum
                }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-top:20px;overflow-x:scroll;">
          <table border class="table-tr">
            <thead>
              <tr class="table-tr-td table-own">
                <th style="width:10%">采购计划编号</th>
                <th style="width:10%">品牌</th>
                <th style="width:10%">系列</th>
                <th>产品名称</th>
                <th>型号</th>
                <th>订货号</th>
                <th>单位</th>
                <th>采购数量</th>
                <th>单品报价</th>
                <th>报价总额</th>
                <th>类型</th>
                <th>货期</th>
                <th>预计发货时间</th>
                <th>计划生成时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <draggable
              v-model="item.orderContractStockupPurchasesVoList"
              :options="{
                group: 'people',
                sort: false,
                scroll: true,
                scrollSensitivity: 200
              }"
              @change="change"
              @start="start"
              @end="end"
              element="tbody"
            >
              <tr
                class="table-tr-td"
                v-for="(items,
                indexs) in item.orderContractStockupPurchasesVoList"
                :key="indexs"
              >
                <td>{{ items.ocspCode }}</td>
                <td>{{ items.brandName }}</td>
                <td>{{ items.seriesName }}</td>
                <td>{{ items.proName }}</td>
                <td class="approval">{{ items.proType }}</td>
                <td>{{ items.orderNumber }}</td>
                <td>{{ items.cbUnit }}</td>
                <td>
                  <el-input-number
                    @change="changeInputNumner"
                    controls-position="right"
                    @input="inputNumber(items.ocspId, indexs)"
                    :max="items.stockupCount"
                    v-model="items.stockupCount"
                    :min="1"
                  ></el-input-number>
                </td>
                <td>
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    v-model="items.cbPrice"
                    :min="0.01"
                  ></el-input-number>
                </td>
                <td>{{ items.stockupCount * items.cbPrice }}</td>
                <td>{{ items.cbExtype }}</td>
                <td>{{ items.cbExtimeValue }}</td>
                <td>{{ items.deliveryTime | dateFilter }}</td>
                <td>{{ items.createDate | dateFilter }}</td>
                <td class="approval" @click="returnWait(item, items, indexs, index)">撤销</td>
              </tr>
            </draggable>
          </table>
          <div
            style="width:100%;text-align:center;"
            v-if="item.orderContractStockupPurchasesVoList.length===0"
          >
            <span style="padding:20px;color:#909399;">暂无数据</span>
          </div>
        </div>
        <div style="padding:20px 30px 0 30px;">
          <el-button type="primary" @click="onReconfirm(1, index)">生成采购合同</el-button>
          <el-button type="primary" @click="onReconfirm(2, index)" plain>移除供应商</el-button>
        </div>
        <div class="solid" style="margin:30px 0 0 0;"></div>
      </div>
      <div style="padding:20px 30px 0 30px">
        <el-button @click="onAddSupplier" type="primary" plain>添加供应商</el-button>
      </div>
      <draggable
        :options="{
          group: 'people',
          sort: false,
          scroll: true,
          scrollSensitivity: 200
        }"
        @change="change"
        @start="start"
        @end="end"
        element="div"
      >
        <div class="frame add-supplier-quickly">拖入产品快速添加供应商</div>
      </draggable>
    </div>
    <!-------------- 添加供应商 -------------->
    <retrieve-suppliers-dialog ref="retrieveSuppliersDialogRefs" @addSupplier="addSupplier"></retrieve-suppliers-dialog>
    <!-------------- 待采购清单库存详情 -------------->
    <wait-purchase-listDrawer ref="waitPurchaseListDrawerRefs" @param="waitPurchaseList"></wait-purchase-listDrawer>
    <!-------------- 生成采购合同,移除供应商 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
    <!-------------- 合同生成区 -------------->
    <contract-generation
      v-show="$route.query.type === 'result' || contract.length > 0"
      ref="contracts"
      :data="contract"
    ></contract-generation>
  </div>
</template>
<script>
import {
  queryOrderContractStockupPurchaseListsVo,
  addPurchaseContractBase,
  queryByContract,
  querySuNameBySuId,
  queryAllContract
} from '@/api/purchase/purchasePlanList'
import draggable from 'vuedraggable'
import retrieveSuppliersDialog from '../../dialog/retrieveSuppliersDialog'
import waitPurchaseListDrawer from '../../dialog/waitPurchaseListDrawer'
import contractGeneration from './contractGeneration'
import OpenOrClose from '@/components/OpenOrClose/index'
import { formatDate } from '@/util/tool'
export default {
  components: {
    'retrieve-suppliers-dialog': retrieveSuppliersDialog,
    'wait-purchase-listDrawer': waitPurchaseListDrawer,
    'open-or-close-dialog': OpenOrClose,
    'contract-generation': contractGeneration,
    draggable
  },
  data () {
    return {
      status: ['平台渠道', '供应商', '厂家', '经销商'],
      cbPriceSource: ['系统', '人工', '特价审批', '其他'],
      contract: [], // 合同生成区
      changeNumberNum: 0,
      orderContractStockupPurchaseListsVo: {}, // 上面基本信息
      list: [],
      indexChange: '',
      bigArray: [],
      listSupplier: [{}],
      content: '',
      procurementList: [],
      title: '',
      isSupplier: false,
      isProduct: false
    }
  },
  mounted () {
    if (this.$route.query.type === 'result') {
      queryAllContract(this.$route.query.ocspCode)
        .then((res) => {
          if (res.data.code === 200) {
            this.contract =
              res.data.obj.orderContractStockPurchaseContractVoList // 采购生成区
            this.orderContractStockupPurchaseListsVo = res.data.obj // 上面基本信息
          }
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      this.queryByContract()
      queryOrderContractStockupPurchaseListsVo(
        this.$route.query.ocspCode,
        this.$route.query.isOcspMeger
      )
        .then((res) => {
          if (res.data.code === 200) {
            this.orderContractStockupPurchaseListsVo =
              res.data.obj.orderContractStockupPurchaseListsVo
            this.list = res.data.obj.orderContractStockupPurchasesVoList
            this.bigArray = JSON.parse(JSON.stringify(this.list))
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },

  methods: {
    // 撤销
    returnWait (item, items, index, indexs) {
      this.list.push(
        this.procurementList[index].orderContractStockupPurchasesVoList[indexs]
      )
      this.procurementList[index].orderContractStockupPurchasesVoList.splice(
        indexs,
        1
      )
      this.changeData()
    },
    queryByContract () {
      queryByContract(this.$route.query.ocspCode)
        .then((res) => {
          if (res.data.code === 200) {
            this.contract = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onAllFold () {
      const arrList = []
      const arrayList = JSON.parse(JSON.stringify(this.list))
      for (var i = 0; i < arrayList.length - 1; i++) {
        for (var j = i + 1; j < arrayList.length; j++) {
          if (arrayList[i].suId === arrayList[j].suId) {
            arrList.push(arrayList[j])
            arrayList.splice(j, 1)
            j--
          }
        }
      }

      this.getList(arrayList)
      setTimeout(() => {
        this.getList(arrList)
      }, 500)
      this.list = []
    },
    getList (arrList) {
      arrList.forEach((element, index) => {
        let isSwitch = false
        this.procurementList.forEach((param, indexs) => {
          if (param.suId === element.suId) {
            isSwitch = true
            let isParams = false
            param.orderContractStockupPurchasesVoList.forEach(
              (ele, indexss) => {
                if (ele.ocspId === element.ocspId) {
                  ele.stockupCount += element.stockupCount
                  isParams = true
                }
              }
            )
            if (!isParams) {
              param.orderContractStockupPurchasesVoList.push(element)
            }
          }
        })
        if (!isSwitch) {
          querySuNameBySuId(element.suId)
            .then((res) => {
              if (res.data.code === 200) {
                const params = {
                  accountBalance: res.data.obj.accountBalance,
                  amounts: res.data.obj.amounts,
                  orderContractStockupPurchasesVoList: [],
                  pcbCount: res.data.obj.pcbCount,
                  staffUsename: res.data.obj.staffUsename,
                  suCode: res.data.obj.suCode,
                  suId: res.data.obj.suId,
                  suName: res.data.obj.suName,
                  suType: res.data.obj.suType
                }
                params.orderContractStockupPurchasesVoList.push(element)
                this.procurementList.push(params)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      })
    },
    changeInputNumner (val, data) {
      this.changeNumberNum = data - val
    },
    inputNumber (val, index) {
      let isParam = false
      for (let j = 0; j < this.list.length; j++) {
        if (this.list[j].ocspId === val) {
          this.list[j].stockupCount += this.changeNumberNum
          isParam = true
          this.changeNumberNum = 0
        }
      }
      if (!isParam) {
        for (let i = 0; i < this.bigArray.length; i++) {
          if (this.bigArray[i].ocspId === val) {
            const params = JSON.parse(JSON.stringify(this.bigArray))[i]
            params.stockupCount = this.changeNumberNum
            this.changeNumberNum = 0
            this.list.push(params)
          }
        }
        for (let z = 0; z < this.list.length; z++) {
          if (this.list[z].stockupCount === 0) {
            this.list.splice(z, 1)
            z--
          }
        }
      }
    },
    clickChangeSupplier (index) {
      this.$refs.retrieveSuppliersDialogRefs.onInitial(index)
    },
    change (evt) {
      if (evt !== undefined) {
        if (evt.removed !== undefined) {
          this.element = evt.removed.element
        }
        this.changeData()
      }
    },
    // 处理数据
    changeData () {
      for (let i = 0; i < this.list.length; i++) {
        for (let z = 0; z < this.bigArray.length; z++) {
          if (this.list[i].ocspId === this.bigArray[z].ocspId) {
            this.list[i].cbPrice = this.bigArray[z].cbPrice
          }
        }
        for (let j = 0; j < this.list.length; j++) {
          if (this.list[i].ocspId === this.list[j].ocspId && i !== j) {
            this.list[i].stockupCount += this.list[j].stockupCount
            this.list.splice(j, 1)
            j--
          }
        }
      }

      for (let i = 0; i < this.procurementList.length; i++) {
        for (
          let m = 0;
          m <
          this.procurementList[i].orderContractStockupPurchasesVoList.length;
          m++
        ) {
          for (let z = 0; z < this.bigArray.length; z++) {
            if (
              this.procurementList[i].orderContractStockupPurchasesVoList[m]
                .ocspId === this.bigArray[z].ocspId
            ) {
              this.procurementList[i].orderContractStockupPurchasesVoList[
                m
              ].cbPrice = this.bigArray[z].cbPrice
            }
          }
          for (
            let j = 0;
            j <
            this.procurementList[i].orderContractStockupPurchasesVoList.length;
            j++
          ) {
            if (
              this.procurementList[i].orderContractStockupPurchasesVoList[m]
                .ocspId ===
                this.procurementList[i].orderContractStockupPurchasesVoList[j]
                  .ocspId &&
              m !== j
            ) {
              this.procurementList[i].orderContractStockupPurchasesVoList[
                m
              ].stockupCount += this.procurementList[
                i
              ].orderContractStockupPurchasesVoList[j].stockupCount
              this.procurementList[
                i
              ].orderContractStockupPurchasesVoList.splice(j, 1)
              j--
            }
          }
        }
        if (
          this.procurementList[i].orderContractStockupPurchasesVoList.length ===
          0
        ) {
          this.procurementList.splice(i, 1)
          i--
        }
      }
    },
    start: function (evt) {},
    end: function (evt) {
      evt.to.classList.add('divElement')
      if (document.querySelectorAll('.divElement .frame').length > 0) {
        const data = JSON.parse(JSON.stringify(this.element))
        evt.to.classList.remove('divElement')
        let isSwitch = false
        this.procurementList.forEach((element, index) => {
          if (element.suId === this.element.suId) {
            this.$message.error('供应商已存在，已合并到指定位置')
            isSwitch = true
            let isParams = false
            element.orderContractStockupPurchasesVoList.forEach(
              (param, indexs) => {
                if (param.ocspId === this.element.ocspId) {
                  param.stockupCount += this.element.stockupCount
                  isParams = true
                }
              }
            )
            if (!isParams) {
              element.orderContractStockupPurchasesVoList.push(this.element)
            }
          }
        })
        if (!isSwitch) {
          querySuNameBySuId(data.suId)
            .then((res) => {
              if (res.data.code === 200) {
                const params = {
                  accountBalance: res.data.obj.accountBalance,
                  amounts: res.data.obj.amounts,
                  orderContractStockupPurchasesVoList: [],
                  pcbCount: res.data.obj.pcbCount,
                  staffUsename: res.data.obj.staffUsename,
                  suCode: res.data.obj.suCode,
                  suId: res.data.obj.suId,
                  suName: res.data.obj.suName,
                  suType: res.data.obj.suType
                }
                params.orderContractStockupPurchasesVoList.push(data)
                this.procurementList.push(params)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 查看
    onSee (val, index) {
      const params = JSON.parse(JSON.stringify(val))
      this.$refs.waitPurchaseListDrawerRefs.onInitial(params, index)
    },
    // 添加供应商
    onAddSupplier () {
      this.$refs.retrieveSuppliersDialogRefs.onInitial()
    },
    // 确定添加供应商
    addSupplier (val, index) {
      if (index === undefined) {
        let isBool = false
        for (let i = 0; i < this.procurementList.length; i++) {
          if (this.procurementList[i].suId === val.suId) {
            this.$message.error('该供应商已存在')
            isBool = true
          }
        }
        if (!isBool) {
          const params = {
            accountBalance: val.accountBalance,
            amounts: val.amounts,
            orderContractStockupPurchasesVoList: [],
            pcbCount: val.pcbCount,
            staffUsename: val.staffUsename,
            suCode: val.suCode,
            suId: val.suId,
            suName: val.suName,
            suType: val.suType
          }
          this.procurementList.push(params)
        }
        this.isSupplier = true
      } else {
        let isBool = false
        for (let i = 0; i < this.procurementList.length; i++) {
          if (this.procurementList[i].suId === val.suId) {
            this.$message.error('该供应商已存在')
            isBool = true
          }
        }
        if (!isBool) {
          this.procurementList[index].accountBalance = val.accountBalance
          this.procurementList[index].amounts = val.amounts
          this.procurementList[index].pcbCount = val.pcbCount
          this.procurementList[index].suCode = val.suCode
          this.procurementList[index].suId = val.suId
          this.procurementList[index].suName = val.suName
          this.procurementList[index].suType = val.suType
        }
      }
    },
    // 生成采购合同,移除供应商
    onReconfirm (type, index) {
      if (type === 1) {
        this.title = '生成采购合同'
        this.content =
          '请再次确认是否生成合同，生成合同后，当前供应商不再允许加入产品；已加入产品除非合同作废否则不得调整至其他供应商。 '
      } else if (type === 2) {
        this.title = '移除供应商'
        this.content =
          '请再次确认是否移除供应商，移除供应商后已分配的产品将返回待采购清单。  '
      }
      this.indexChange = index
      this.$refs.openOrCloseRefs.onInitial(type)
    },
    // 确认生成采购合同,移除供应商
    onUpdataState (type) {
      if (type === 1) {
        const param = this.orderContractStockupPurchaseListsVo
        param.orderContractStockupPurchasesVoList = this.procurementList[
          this.indexChange
        ].orderContractStockupPurchasesVoList
        param.orderContractStockupPurchasesVoList.forEach((element) => {
          delete element.suId
          delete element.storageCount
          delete element.suName
        })
        addPurchaseContractBase(
          this.procurementList[this.indexChange].suId,
          param
        )
          .then((res) => {
            if (res.data.code === 200) {
              this.queryByContract()
              this.procurementList.splice(this.indexChange, 1)
              this.$message.success('操作成功')
            }
          })
          .catch((err) => {
            console.log(err)
          })
        // 处理数据
      } else if (type === 2) {
        if (
          this.procurementList[this.indexChange]
            .orderContractStockupPurchasesVoList.length !== 0
        ) {
          this.procurementList[
            this.indexChange
          ].orderContractStockupPurchasesVoList.forEach((res) => {
            this.bigArray.forEach((element) => {
              if (element.ocspId === res.ocspId) {
                const params = JSON.parse(JSON.stringify(element))
                params.stockupCount = res.stockupCount
                this.list.push(params)
              }
            })
          })
          this.changeData()
        }
        this.procurementList.splice(this.indexChange, 1)
      }
    },
    // 拖入产品
    onAddProduct () {
      this.isProduct = true
    },
    // 供应商传回来的数据
    waitPurchaseList (val, num, index) {
      const arrList = JSON.parse(JSON.stringify(val))
      const arr = []
      this.list[index].stockupCount = this.list[index].stockupCount - num
      if (this.list[index].stockupCount === 0) {
        this.list.splice(index, 1)
      }
      arrList.forEach((res) => {
        const params = res.orderContractStockupPurchasesVo
        params.suId = res.supplierOffersVo.suId
        params.suName = res.supplierOffersVo.suName
        params.stockupCount = res.supplierOffersVo.stockupCount
        arr.push(params)
      })
      arr.forEach((element, index) => {
        let isSwitch = false
        this.procurementList.forEach((param, indexs) => {
          if (param.suId === element.suId) {
            isSwitch = true
            let isParams = false
            param.orderContractStockupPurchasesVoList.forEach(
              (ele, indexss) => {
                if (ele.ocspId === element.ocspId) {
                  ele.stockupCount += element.stockupCount
                  isParams = true
                }
              }
            )
            if (!isParams) {
              param.orderContractStockupPurchasesVoList.push(
                JSON.parse(JSON.stringify(element))
              )
            }
          }
        })
        if (!isSwitch) {
          querySuNameBySuId(element.suId)
            .then((res) => {
              if (res.data.code === 200) {
                const params = {
                  accountBalance: res.data.obj.accountBalance,
                  amounts: res.data.obj.amounts,
                  orderContractStockupPurchasesVoList: [],
                  pcbCount: res.data.obj.pcbCount,
                  staffUsename: res.data.obj.staffUsename,
                  suCode: res.data.obj.suCode,
                  suId: res.data.obj.suId,
                  suName: res.data.obj.suName,
                  suType: res.data.obj.suType
                }
                params.orderContractStockupPurchasesVoList.push(
                  JSON.parse(JSON.stringify(element))
                )
                this.procurementList.push(JSON.parse(JSON.stringify(params)))
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      })
    }
  },
  filters: {
    dateFilter
  }
}

function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
.add-supplier-quickly {
  height: 162px;
  line-height: 162px;
  background: rgba(243, 247, 255, 1);
  border-radius: 10px;
  width: 100%;
  text-align: center;
  margin-top: 20px;
}
.table-tr {
  margin-top: 20px;
  width: 1800px;
  font-size: 13px;
  text-align: left;
  .table-tr-td {
    text-align: left;
    th {
      padding-left: 5px;
      font-weight: 500;
      font-size: 14px;
    }
    td {
      padding: 8px 5px;
    }
  }
  border-radius: 4px 4px 0px 0px;
  border: none;
  cell-padding: 0;
  cell-spacing: 0;
  border-collapse: collapse;
}
.table-own {
  height: 38px;
  background-color: #f6f7fa;
  padding: 10px !important;
}
</style>
